import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "px-2 py-1 d-flex align-items-center" }
const _hoisted_2 = ["aria-pressed", "title"]
const _hoisted_3 = ["aria-pressed", "title"]
const _hoisted_4 = ["aria-pressed", "title"]
const _hoisted_5 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_6 = { class: "row text-center m-0" }
const _hoisted_7 = ["title", "aria-label", "aria-pressed", "onClick"]
const _hoisted_8 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_9 = { class: "row text-center m-0" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "col-4 d-flex align-items-center justify-content-center user-select-none" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = ["aria-pressed"]
const _hoisted_16 = ["aria-pressed"]
const _hoisted_17 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_18 = {
  enctype: "multipart/form-data",
  tabindex: "-1",
  ref: "opmlInputForm"
}
const _hoisted_19 = {
  class: "c-dropdown-item d-block text-start text-decoration-none",
  href: "./opml/export"
}
const _hoisted_20 = { class: "container" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = ["aria-label", "aria-pressed", "title", "onClick"]
const _hoisted_23 = {
  key: 0,
  class: "c-dropdown-divider"
}
const _hoisted_24 = {
  id: "feed-list-scroll",
  class: "p-2 overflow-auto border-top flex-grow-1"
}
const _hoisted_25 = {
  key: 0,
  class: "px-2 py-1 d-flex align-items-center border-top flex-shrink-0"
}
const _hoisted_26 = { class: "text-truncate cursor-default user-select-none" }
const _hoisted_27 = { class: "px-2 py-1 d-flex gap-1 align-items-center" }
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "c-search flex-grow-1" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = ["title"]
const _hoisted_32 = {
  key: 1,
  class: "c-button-link c-button-pill px-2",
  disabled: ""
}
const _hoisted_33 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 2,
  class: "c-dropdown-divider"
}
const _hoisted_37 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  class: "c-dropdown-header",
  role: "heading",
  "aria-level": "2"
}
const _hoisted_40 = {
  id: "item-list-scroll",
  class: "d-flex flex-column p-2 overflow-auto border-top flex-grow-1 gap-1",
  ref: "itemlist"
}
const _hoisted_41 = ["aria-checked", "onClick"]
const _hoisted_42 = {
  style: {"line-height":"100%","opacity":"0.7","margin-bottom":"0.1rem"},
  class: "d-flex align-items-center"
}
const _hoisted_43 = { class: "flex-fill text-truncate me-1" }
const _hoisted_44 = { class: "flex-shrink-0" }
const _hoisted_45 = { class: "text-break line-clamp-3" }
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  key: 0,
  class: "text-center my-3"
}
const _hoisted_48 = {
  key: 0,
  class: "px-3 py-2 border-top text-danger text-break"
}
const _hoisted_49 = {
  id: "col-item",
  class: "vh-100 d-flex flex-column w-100",
  style: {"min-width":"0"}
}
const _hoisted_50 = {
  key: 0,
  class: "px-2 py-1 d-flex gap-1 align-items-center"
}
const _hoisted_51 = ["title"]
const _hoisted_52 = ["title"]
const _hoisted_53 = ["aria-pressed"]
const _hoisted_54 = ["aria-pressed"]
const _hoisted_55 = ["aria-pressed"]
const _hoisted_56 = { class: "d-flex text-center" }
const _hoisted_57 = ["aria-pressed", "title"]
const _hoisted_58 = ["href", "title"]
const _hoisted_59 = ["title", "disabled"]
const _hoisted_60 = ["title", "disabled"]
const _hoisted_61 = ["title"]
const _hoisted_62 = { class: "content-wrapper" }
const _hoisted_63 = ["href"]
const _hoisted_64 = { class: "opacity-50" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = ["src"]
const _hoisted_68 = { key: 0 }
const _hoisted_69 = ["src"]
const _hoisted_70 = ["src"]
const _hoisted_71 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_drag = _resolveComponent("v-drag")
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_dropdown = _resolveComponent("v-dropdown")
  const _component_v_feedtree = _resolveComponent("v-feedtree")
  const _component_v_relative_time = _resolveComponent("v-relative-time")
  const _component_v_newfeed = _resolveComponent("v-newfeed")
  const _component_v_shortcuts = _resolveComponent("v-shortcuts")
  const _component_v_modal = _resolveComponent("v-modal")
  const _component_v_toast = _resolveComponent("v-toast")
  const _directive_scroll = _resolveDirective("scroll")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex", {
      'feed-selected': _ctx.feedSelected !== null,
      'item-selected': _ctx.itemSelected !== null,
    }])
  }, [
    _createCommentVNode(" feed list "),
    _createElementVNode("div", {
      id: "col-feed-list",
      class: "vh-100 position-relative d-flex flex-column border-end flex-shrink-0",
      style: _normalizeStyle({ width: _ctx.feedListWidth + 'px' })
    }, [
      _createVNode(_component_v_drag, {
        width: _ctx.feedListWidth,
        onResize: _ctx.resizeFeedList
      }, null, 8 /* PROPS */, ["width", "onResize"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          class: "mx-2",
          name: "anchor"
        }),
        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1 /* CACHED */)),
        _createElementVNode("button", {
          class: "c-button-pill ms-1",
          "aria-pressed": _ctx.filterSelected == 'unread',
          title: _ctx.$t('unread'),
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.filterSelected = 'unread'))
        }, [
          _createVNode(_component_v_icon, { name: "circle-full" })
        ], 8 /* PROPS */, _hoisted_2),
        _createElementVNode("button", {
          class: "c-button-pill mx-1",
          "aria-pressed": _ctx.filterSelected == 'starred',
          title: _ctx.$t('starred'),
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.filterSelected = 'starred'))
        }, [
          _createVNode(_component_v_icon, { name: "star-full" })
        ], 8 /* PROPS */, _hoisted_3),
        _createElementVNode("button", {
          class: "c-button-pill me-1",
          "aria-pressed": _ctx.filterSelected == '',
          title: _ctx.$t('all'),
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.filterSelected = ''))
        }, [
          _createVNode(_component_v_icon, { name: "assorted" })
        ], 8 /* PROPS */, _hoisted_4),
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1 /* CACHED */)),
        _createVNode(_component_v_dropdown, {
          "toggle-class": "c-button-link c-button-pill px-2",
          ref: "menuDropdown",
          drop: "right",
          title: _ctx.$t('settings')
        }, {
          button: _withCtx(() => [
            _createVNode(_component_v_icon, { name: "more-horizontal" })
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "c-dropdown-item w-100 text-start",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.showModal = 'newfeed'))
            }, [
              _createVNode(_component_v_icon, {
                class: "me-1",
                name: "plus"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("new_feed")), 1 /* TEXT */)
            ]),
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              class: "c-dropdown-item w-100 text-start",
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.fetchAllFeeds()))
            }, [
              _createVNode(_component_v_icon, {
                class: "me-1",
                name: "rotate-cw"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("refresh_feeds")), 1 /* TEXT */)
            ]),
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("header", _hoisted_5, _toDisplayString(_ctx.$t("theme")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['light', 'sepia', 'night', 'system'], (t) => {
                return _createElementVNode("button", {
                  class: _normalizeClass(["c-button-link theme-swatch col-3 px-0 rounded-0", 'theme-' + t]),
                  title: t,
                  "aria-label": t,
                  "aria-pressed": _ctx.theme.name == t,
                  onClick: _withModifiers($event => (_ctx.theme.name = t), ["stop"])
                }, null, 10 /* CLASS, PROPS */, _hoisted_7)
              }), 64 /* STABLE_FRAGMENT */))
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("header", _hoisted_8, _toDisplayString(_ctx.$t("auto_refresh")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "c-dropdown-item col-4 px-0",
                onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.changeRefreshRate(-1)), ["stop"])),
                disabled: !_ctx.refreshRate
              }, [
                _createVNode(_component_v_icon, { name: "chevron-down" })
              ], 8 /* PROPS */, _hoisted_10),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.refreshRateTitle), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "c-dropdown-item col-4 px-0",
                onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.changeRefreshRate(1)), ["stop"])),
                disabled: _ctx.refreshRate === _ctx.refreshRateOptions[_ctx.refreshRateOptions.length - 1].value
              }, [
                _createVNode(_component_v_icon, { name: "chevron-up" })
              ], 8 /* PROPS */, _hoisted_12)
            ]),
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("header", _hoisted_13, _toDisplayString(_ctx.$t("show_first")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex-fill c-dropdown-item text-center", { active: _ctx.itemSortNewestFirst }]),
                "aria-pressed": _ctx.itemSortNewestFirst,
                onClick: _cache[7] || (_cache[7] = _withModifiers($event => (_ctx.itemSortNewestFirst = true), ["stop"]))
              }, _toDisplayString(_ctx.$t("new")), 11 /* TEXT, CLASS, PROPS */, _hoisted_15),
              _createElementVNode("button", {
                class: _normalizeClass(["flex-fill c-dropdown-item text-center", { active: !_ctx.itemSortNewestFirst }]),
                "aria-pressed": !_ctx.itemSortNewestFirst,
                onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.itemSortNewestFirst = false), ["stop"]))
              }, _toDisplayString(_ctx.$t("old")), 11 /* TEXT, CLASS, PROPS */, _hoisted_16)
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("header", _hoisted_17, _toDisplayString(_ctx.$t("subscriptions")), 1 /* TEXT */),
            _createElementVNode("form", _hoisted_18, [
              _createElementVNode("input", {
                type: "file",
                id: "opml-import",
                onChange: _cache[9] || (_cache[9] = (...args) => (_ctx.importOPML && _ctx.importOPML(...args))),
                name: "opml",
                style: {"opacity":"0","width":"1px","height":"0","position":"absolute","z-index":"-1"}
              }, null, 32 /* NEED_HYDRATION */),
              _createElementVNode("label", {
                class: "c-dropdown-item mb-0 cursor-pointer w-100",
                for: "opml-import",
                onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_v_icon, {
                  class: "me-1",
                  name: "download"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("import")), 1 /* TEXT */)
              ])
            ], 512 /* NEED_PATCH */),
            _createElementVNode("a", _hoisted_19, [
              _createVNode(_component_v_icon, {
                class: "me-1",
                name: "upload"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("export")), 1 /* TEXT */)
            ]),
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              class: "c-dropdown-item w-100 text-start",
              onClick: _cache[11] || (_cache[11] = $event => (_ctx.showModal = 'shortcuts'))
            }, [
              _createVNode(_component_v_icon, {
                class: "me-1",
                name: "help-circle"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("shortcuts")), 1 /* TEXT */)
            ]),
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
            _cache[46] || (_cache[46] = _createElementVNode("header", {
              class: "c-dropdown-header",
              role: "heading",
              "aria-level": "2"
            }, "A / あ / 文", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: "c-dropdown-item text-center col-3 px-0",
                    "aria-label": lang.name,
                    "aria-pressed": _ctx.language === lang.code,
                    title: lang.name,
                    onClick: _withModifiers($event => (_ctx.changeLanguage(lang.code)), ["stop"])
                  }, _toDisplayString(lang.code), 9 /* TEXT, PROPS */, _hoisted_22))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]),
            (_ctx.requiresAuth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23))
              : _createCommentVNode("v-if", true),
            (_ctx.requiresAuth)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "c-dropdown-item w-100 text-start",
                  onClick: _cache[12] || (_cache[12] = $event => (_ctx.logout()))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "me-1",
                    name: "log-out"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("log_out")), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_v_feedtree, {
          tree: _ctx.feedTree,
          modelValue: _ctx.feedSelected,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.feedSelected) = $event)),
          "filter-selected": _ctx.filterSelected,
          stats: _ctx.stats,
          "feed-errors": _ctx.feed_errors,
          onToggleFolder: _ctx.toggleFolderExpanded
        }, null, 8 /* PROPS */, ["tree", "modelValue", "filter-selected", "stats", "feed-errors", "onToggleFolder"])
      ]),
      (_ctx.loading.feeds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "c-spinner mx-2" }, null, -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("refreshing_progress", { count: _ctx.loading.feeds })), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    _createCommentVNode(" item list "),
    _createElementVNode("div", {
      id: "col-item-list",
      class: "vh-100 position-relative d-flex flex-column border-end flex-shrink-0",
      style: _normalizeStyle({ width: _ctx.itemListWidth + 'px' })
    }, [
      _createVNode(_component_v_drag, {
        width: _ctx.itemListWidth,
        onResize: _ctx.resizeItemList
      }, null, 8 /* PROPS */, ["width", "onResize"]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          class: "c-button-pill d-md-none",
          onClick: _cache[14] || (_cache[14] = $event => (_ctx.feedSelected = null)),
          title: _ctx.$t('show_feeds')
        }, [
          _createVNode(_component_v_icon, { name: "chevron-left" })
        ], 8 /* PROPS */, _hoisted_28),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_v_icon, { name: "search" }),
          _createCommentVNode(" id used by keybindings "),
          _withDirectives(_createElementVNode("input", {
            id: "searchbar",
            class: "d-block",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.itemSearch) = $event)),
            placeholder: _ctx.$t('search_placeholder', { scope: _ctx.searchScope }),
            onKeydown: _cache[16] || (_cache[16] = _withKeys($event => (($event.target as HTMLInputElement).blur()), ["enter"]))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_30), [
            [_vModelText, _ctx.itemSearch]
          ])
        ]),
        (_ctx.filterSelected == 'unread')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "c-button-pill",
              onClick: _cache[17] || (_cache[17] = $event => (_ctx.markItemsRead())),
              title: _ctx.$t('mark_all_read')
            }, [
              _createVNode(_component_v_icon, { name: "check" })
            ], 8 /* PROPS */, _hoisted_31))
          : _createCommentVNode("v-if", true),
        (!_ctx.current.type)
          ? (_openBlock(), _createElementBlock("button", _hoisted_32, [
              _createVNode(_component_v_icon, { name: "more-horizontal" })
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.current?.feed?.id)
          ? (_openBlock(), _createBlock(_component_v_dropdown, {
              key: 2,
              "toggle-class": "c-button-link c-button-pill px-2",
              drop: "right",
              title: _ctx.$t('feed_settings')
            }, {
              button: _withCtx(() => [
                _createVNode(_component_v_icon, { name: "more-horizontal" })
              ]),
              default: _withCtx(() => [
                _createElementVNode("header", _hoisted_33, _toDisplayString(_ctx.current?.feed?.title), 1 /* TEXT */),
                (_ctx.current?.feed?.link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "c-dropdown-item d-block text-start text-decoration-none",
                      href: _ctx.current?.feed?.link,
                      rel: "noopener noreferrer",
                      target: "_blank",
                      referrerpolicy: "no-referrer"
                    }, [
                      _createVNode(_component_v_icon, {
                        class: "me-1",
                        name: "globe"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("website")), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_34))
                  : _createCommentVNode("v-if", true),
                (_ctx.current.feed.feed_link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "c-dropdown-item d-block text-start text-decoration-none",
                      href: _ctx.current.feed.feed_link,
                      rel: "noopener noreferrer",
                      target: "_blank",
                      referrerpolicy: "no-referrer"
                    }, [
                      _createVNode(_component_v_icon, {
                        class: "me-1",
                        name: "rss"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("feed_link")), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_35))
                  : _createCommentVNode("v-if", true),
                (_ctx.current.feed.link || _ctx.current.feed.feed_link)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start",
                  onClick: _cache[18] || (_cache[18] = $event => (_ctx.renameFeed(_ctx.current.feed)))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "me-1",
                    name: "edit"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("rename")), 1 /* TEXT */)
                ]),
                (_ctx.current.feed.feed_link)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "c-dropdown-item w-100 text-start",
                      onClick: _cache[19] || (_cache[19] = $event => (_ctx.updateFeedLink(_ctx.current.feed)))
                    }, [
                      _createVNode(_component_v_icon, {
                        class: "me-1",
                        name: "edit"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("change_link")), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _cache[51] || (_cache[51] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
                _createElementVNode("header", _hoisted_37, _toDisplayString(_ctx.$t("move_to")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (folder.id != _ctx.current.feed.folder_id)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "c-dropdown-item w-100 text-start",
                          onClick: $event => (_ctx.moveFeed(_ctx.current.feed, folder.id))
                        }, [
                          _createVNode(_component_v_icon, {
                            class: "me-1",
                            name: "folder"
                          }),
                          _createTextVNode(" " + _toDisplayString(folder.title), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_38))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */)),
                (_ctx.current.feed.folder_id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      class: "c-dropdown-item w-100 text-start opacity-75",
                      onClick: _cache[20] || (_cache[20] = $event => (_ctx.moveFeed(_ctx.current.feed, null)))
                    }, [
                      _createVNode(_component_v_icon, {
                        class: "me-1",
                        name: "folder-minus"
                      }),
                      _cache[50] || (_cache[50] = _createTextVNode(" ── ", -1 /* CACHED */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start opacity-75",
                  onClick: _cache[21] || (_cache[21] = $event => (_ctx.moveFeedToNewFolder(_ctx.current.feed)))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "me-1",
                    name: "folder-plus"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("new_folder")), 1 /* TEXT */)
                ]),
                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start text-danger",
                  onClick: _cache[22] || (_cache[22] = _withModifiers($event => (_ctx.deleteFeed(_ctx.current.feed)), ["prevent"]))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "me-1",
                    name: "trash"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("delete")), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true),
        (_ctx.current?.folder?.id)
          ? (_openBlock(), _createBlock(_component_v_dropdown, {
              key: 3,
              "toggle-class": "c-button-link c-button-pill px-2",
              title: _ctx.$t('folder_settings'),
              drop: "right"
            }, {
              button: _withCtx(() => [
                _createVNode(_component_v_icon, { name: "more-horizontal" })
              ]),
              default: _withCtx(() => [
                _createElementVNode("header", _hoisted_39, _toDisplayString(_ctx.current?.folder?.title), 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start",
                  onClick: _cache[23] || (_cache[23] = $event => (_ctx.renameFolder(_ctx.current.folder)))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "me-1",
                    name: "edit"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("rename")), 1 /* TEXT */)
                ]),
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "c-dropdown-divider" }, null, -1 /* CACHED */)),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start text-danger",
                  onClick: _cache[24] || (_cache[24] = $event => (_ctx.deleteFolder(_ctx.current.folder)))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "me-1",
                    name: "trash"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("delete")), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "c-listitem d-flex flex-column user-select-none",
            role: "radio",
            "aria-checked": _ctx.itemSelected === item.id,
            onClick: $event => (_ctx.itemSelected = item.id)
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_Transition, { name: "indicator" }, {
                default: _withCtx(() => [
                  (item.status == 'unread')
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        small: true,
                        class: "me-1",
                        name: "circle-full"
                      }))
                    : (item.status == 'starred')
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          small: true,
                          class: "me-1",
                          name: "star-full"
                        }))
                      : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */),
              _createElementVNode("small", _hoisted_43, _toDisplayString((_ctx.feedsById[item.feed_id] || {}).title), 1 /* TEXT */),
              _createElementVNode("small", _hoisted_44, [
                _createVNode(_component_v_relative_time, {
                  title: _ctx.formatDate(item.date),
                  val: item.date
                }, null, 8 /* PROPS */, ["title", "val"])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, _toDisplayString(item.title || _ctx.$t("untitled")), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.media_links || []).filter(l => l.type === 'image').slice(0, 1), (media) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("img", {
                  src: media.url,
                  loading: "lazy",
                  referrerpolicy: "no-referrer",
                  style: {"width":"100%","aspect-ratio":"1.91 / 1","object-fit":"cover"}
                }, null, 8 /* PROPS */, _hoisted_46)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_41))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.itemsHasMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[54] || (_cache[54] = [
              _createElementVNode("span", { class: "c-spinner" }, null, -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true)
      ])), [
        [_directive_scroll, _ctx.loadMoreItems]
      ]),
      (_ctx.current?.feed?.id && _ctx.feed_errors[_ctx.current.feed.id])
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.feed_errors[_ctx.current.feed.id]), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    _createCommentVNode(" item show "),
    _createElementVNode("div", _hoisted_49, [
      (_ctx.itemSelectedDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createElementVNode("button", {
              class: "c-button-pill",
              onClick: _cache[25] || (_cache[25] = $event => (_ctx.toggleItemStarred(_ctx.itemSelectedDetails))),
              title: _ctx.$t('mark_starred')
            }, [
              (_ctx.itemSelectedDetails.status == 'starred')
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    name: "star-full"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    name: "star"
                  }))
            ], 8 /* PROPS */, _hoisted_51),
            _createElementVNode("button", {
              class: "c-button-pill",
              title: _ctx.$t('mark_unread'),
              onClick: _cache[26] || (_cache[26] = $event => (_ctx.toggleItemRead(_ctx.itemSelectedDetails)))
            }, [
              (_ctx.itemSelectedDetails.status == 'unread')
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    name: "circle-full"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    name: "circle"
                  }))
            ], 8 /* PROPS */, _hoisted_52),
            _createVNode(_component_v_dropdown, {
              "toggle-class": "c-button-pill px-2",
              drop: "center",
              title: _ctx.$t('appearance')
            }, {
              button: _withCtx(() => [
                _createVNode(_component_v_icon, { name: "sliders" })
              ]),
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start font-sans-serif",
                  "aria-pressed": _ctx.theme.font == '',
                  onClick: _cache[27] || (_cache[27] = _withModifiers($event => (_ctx.theme.font = ''), ["stop"]))
                }, _toDisplayString(_ctx.$t("sans_serif")), 9 /* TEXT, PROPS */, _hoisted_53),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start font-serif",
                  "aria-pressed": _ctx.theme.font == 'serif',
                  onClick: _cache[28] || (_cache[28] = _withModifiers($event => (_ctx.theme.font = 'serif'), ["stop"]))
                }, _toDisplayString(_ctx.$t("serif")), 9 /* TEXT, PROPS */, _hoisted_54),
                _createElementVNode("button", {
                  class: "c-dropdown-item w-100 text-start font-monospace",
                  "aria-pressed": _ctx.theme.font == 'monospace',
                  onClick: _cache[29] || (_cache[29] = _withModifiers($event => (_ctx.theme.font = 'monospace'), ["stop"]))
                }, _toDisplayString(_ctx.$t("monospace")), 9 /* TEXT, PROPS */, _hoisted_55),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("button", {
                    class: "c-dropdown-item flex-fill",
                    style: {"font-size":"0.8rem"},
                    onClick: _cache[30] || (_cache[30] = _withModifiers($event => (_ctx.incrFont(-1)), ["stop"]))
                  }, " A "),
                  _createElementVNode("button", {
                    class: "c-dropdown-item flex-fill",
                    style: {"font-size":"1.2rem"},
                    onClick: _cache[31] || (_cache[31] = _withModifiers($event => (_ctx.incrFont(1)), ["stop"]))
                  }, " A ")
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]),
            _createElementVNode("button", {
              class: "c-button-pill",
              "aria-pressed": !!_ctx.itemSelectedReadability,
              onClick: _cache[32] || (_cache[32] = $event => (_ctx.toggleReadability())),
              title: _ctx.$t('read_here')
            }, [
              _createVNode(_component_v_icon, {
                class: _normalizeClass({ 'is-loading': _ctx.loading.readability }),
                name: "book-open"
              }, null, 8 /* PROPS */, ["class"])
            ], 8 /* PROPS */, _hoisted_57),
            _createElementVNode("a", {
              class: "c-button-pill",
              href: _ctx.itemSelectedDetails.link,
              rel: "noopener noreferrer",
              target: "_blank",
              referrerpolicy: "no-referrer",
              title: _ctx.$t('open_link')
            }, [
              _createVNode(_component_v_icon, { name: "external-link" })
            ], 8 /* PROPS */, _hoisted_58),
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              class: "c-button-pill",
              onClick: _cache[33] || (_cache[33] = $event => (_ctx.navigateToItem(-1))),
              title: _ctx.$t('previous_article'),
              disabled: !_ctx.items.length || _ctx.itemSelected == _ctx.items[0].id
            }, [
              _createVNode(_component_v_icon, { name: "chevron-left" })
            ], 8 /* PROPS */, _hoisted_59),
            _createElementVNode("button", {
              class: "c-button-pill",
              onClick: _cache[34] || (_cache[34] = $event => (_ctx.navigateToItem(+1))),
              title: _ctx.$t('next_article'),
              disabled: !_ctx.items.length || _ctx.itemSelected == _ctx.items[_ctx.items.length - 1].id
            }, [
              _createVNode(_component_v_icon, { name: "chevron-right" })
            ], 8 /* PROPS */, _hoisted_60),
            _createElementVNode("button", {
              class: "c-button-pill",
              onClick: _cache[35] || (_cache[35] = $event => (_ctx.itemSelected = null)),
              title: _ctx.$t('close_article')
            }, [
              _createVNode(_component_v_icon, { name: "x" })
            ], 8 /* PROPS */, _hoisted_61)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.itemSelectedDetails)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            ref: "content",
            class: _normalizeClass(["content px-4 pt-3 pb-5 border-top overflow-auto", {
          'font-sans-serif': _ctx.theme.font == '',
          'font-serif': _ctx.theme.font == 'serif',
          'font-monospace': _ctx.theme.font == 'monospace',
        }]),
            style: _normalizeStyle({ 'font-size': _ctx.theme.size + 'rem' })
          }, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("h1", null, [
                _createElementVNode("a", {
                  referrerpolicy: "no-referrer",
                  target: "_blank",
                  href: _ctx.itemSelectedDetails.link,
                  style: {"color":"inherit","text-decoration":"none"}
                }, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.itemSelectedDetails.title || _ctx.$t("untitled")), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_63)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: "cursor-pointer",
                    onClick: _cache[36] || (_cache[36] = $event => (_ctx.feedSelected = 'feed:' + (_ctx.feedsById[_ctx.itemSelectedDetails.feed_id] || {}).id))
                  }, _toDisplayString((_ctx.feedsById[_ctx.itemSelectedDetails.feed_id] || {}).title), 1 /* TEXT */)
                ]),
                _createElementVNode("time", null, _toDisplayString(_ctx.formatDate(_ctx.itemSelectedDetails.date)), 1 /* TEXT */)
              ]),
              _cache[56] || (_cache[56] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
              (!_ctx.itemSelectedReadability)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    (_ctx.contentImages.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentImages, (media) => {
                            return (_openBlock(), _createElementBlock("figure", null, [
                              _createElementVNode("img", {
                                src: media.url,
                                loading: "lazy"
                              }, null, 8 /* PROPS */, _hoisted_67),
                              (media.description)
                                ? (_openBlock(), _createElementBlock("figcaption", _hoisted_68, _toDisplayString(media.description), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentAudios, (media) => {
                      return (_openBlock(), _createElementBlock("audio", {
                        class: "w-100",
                        controls: "",
                        src: media.url
                      }, null, 8 /* PROPS */, _hoisted_69))
                    }), 256 /* UNKEYED_FRAGMENT */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentVideos, (media) => {
                      return (_openBlock(), _createElementBlock("video", {
                        class: "w-100",
                        controls: "",
                        src: media.url
                      }, null, 8 /* PROPS */, _hoisted_70))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", { innerHTML: _ctx.itemSelectedContent }, null, 8 /* PROPS */, _hoisted_71)
            ])
          ], 6 /* CLASS, STYLE */))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_v_modal, {
      open: _ctx.showModal !== '',
      onHide: _cache[38] || (_cache[38] = $event => (_ctx.showModal = ''))
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "c-button-link outline-none position-absolute top-0 end-0 p-2 m-2",
          style: {"line-height":"1"},
          onClick: _cache[37] || (_cache[37] = $event => (_ctx.showModal = ''))
        }, [
          _createVNode(_component_v_icon, { name: "x" })
        ]),
        (_ctx.showModal === 'newfeed')
          ? (_openBlock(), _createBlock(_component_v_newfeed, {
              key: 0,
              folders: _ctx.folders,
              "folder-id": _ctx.current?.feed?.folder_id ?? _ctx.current?.folder?.id ?? null,
              onCreated: _ctx.onFeedCreated,
              onFolderCreated: _ctx.refreshFeeds
            }, null, 8 /* PROPS */, ["folders", "folder-id", "onCreated", "onFolderCreated"]))
          : (_ctx.showModal === 'shortcuts')
            ? (_openBlock(), _createBlock(_component_v_shortcuts, { key: 1 }))
            : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    _createVNode(_component_v_toast, { ref: "toast" }, null, 512 /* NEED_PATCH */)
  ], 2 /* CLASS */))
}